import {redirect} from "react-router-dom"

import {getToken} from "../utilities/useToken"

// Educator orientations are for Educators/Admins; preceptors have their own
// views and must not reach these routes directly by URL.
export const checkEducatorOrientationsAccess = () => {
    const {role} = getToken(true) || {}
    if (role === "Preceptor") {
        return redirect("/home")
    }

    return true
}
